import { getKeyByValue } from '../../../utils/ieCompatibility'

export enum RaisonRefusEnum {
	REFLECHIR = 1,
	INCOMPREHENSION = 2,
	INCOMPATIBLE = 3
}

export const getKeyFromRaisonRefusValue = (value: number) => getKeyByValue(RaisonRefusEnum, value) || ''